export function shortenCFI(cfi) {
    return cfi.replace(/^epubcfi\((.+)\)$/, '$1');
}
export function lengthenCFI(cfi) {
    if (cfi.startsWith('epubcfi(') && cfi.endsWith(')')) {
        return cfi;
    }
    else {
        return `epubcfi(${cfi})`;
    }
}
